import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';

import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

@Injectable()
export class ProductService {

    constructor(
        private http: HttpClient,
        private httpOld: Http,
        private global: GlobalDataService
    ) { }


    getProduct(page: number,isActive:number=-1) {
        
        let isAvailable: string ="&active="+isActive
        if(isActive==-1){
            isAvailable="";
        }
        return this.http.get(this.global.httpUrl + "products?page=" + page+isAvailable);
    }

    getProductByFilter(filter: any[],page: number=1,isActive:number=-1) {
        let url = "";
        if(filter){
        url="&";
        for (var item of filter) {
            url += item.name + "=" + item.value + "&";
        }
        url = url.substring(0,url.length-1);
       }
           
        let isAvailable: string ="&active="+isActive;
        if(isActive==-1){
            isAvailable="";
        }

        return this.http.get(this.global.httpUrl + "products?page=" + page+url+isAvailable);
    }

    getProductById(id: any) {
        return this.http.get(this.global.httpUrl + "products/" + id);
    }

    createProduct(data: any) {
        let headers = new Headers(), authtoken = localStorage.getItem('token');
        headers.append("Authorization", 'Bearer' + authtoken);
        headers.append('X-Requested-With', 'XMLHttpRequest');
        headers.append('enctype', 'multipart/form-data');

        return this.httpOld.post(this.global.httpUrl + "products", data, { headers: headers })
            .map((resp: Response) => resp.json())
            .catch((error: any) => { return Observable.throw(error); });

    }

    updateProduct(data: any, id: any) {
        let headers = new Headers(), authtoken = localStorage.getItem('token');
        headers.append("Authorization", 'Bearer' + authtoken);
        headers.append('X-Requested-With', 'XMLHttpRequest');
        headers.append('enctype', 'multipart/form-data');
        return this.httpOld.post(this.global.httpUrl + "products/" + id + "/update", data, { headers: headers })
            .map((resp: Response) => resp.json())
            .catch((error: any) => { return Observable.throw(error); });

    }

    deleteImage(productId: any, imageId: any) {
        return this.http.get(this.global.httpUrl + "products/" + productId + "/delete-image?image_id=" + imageId);
    }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/products/product.service.ts